import * as React from 'react';
import { Dropdown, Icon, Button, Grid, Form } from 'semantic-ui-react';
import Widget from '../Chart/ChartView';
import { ContainerProps } from 'src/shared/typemap';
import { DashboardStore } from 'src/stores/application/dashboard';
import Dashboard from 'src/stores/application/classes/Dashboard';
import Chart from 'src/stores/application/classes/Chart';
import { ChartStore } from 'src/stores/application/chart';
import { inject, observer } from 'mobx-react';
import { AuthStore } from 'src/stores/authStore';
import { Link } from 'react-router-dom';
// import RedirectIfLoggedOut from '../../components/RedirectIfLoggedOut';
import uuidv1 from 'uuid/v1';
import ChartOptions from 'src/container/Chart/ChartOptions';
import { WidthProvider, Responsive } from 'react-grid-layout';
import CenterFramed from 'src/components/CenteredFrame';
import './Dashboard.scss';
import { deepEqual } from 'src/shared/utility';

const ResponsiveReactGridLayout = WidthProvider(Responsive);
type DashboardProps = ContainerProps & {
  dashboards?: DashboardStore;
  charts?: ChartStore;
  authStore?: AuthStore;
  routing?: any;
};

@inject('dashboards', 'charts', 'authStore', 'routing')
@observer
export default class DashboardRender extends React.Component<DashboardProps, any> {
  currentDashboard: Dashboard;
  dashboards: Dashboard[];
  awaitingSave: boolean = false;
  redraw: string = '';

  get isEdit() {
    return !this.awaitingSave && this.currentDashboard && this.state.typedId === this.currentDashboard.typedId;
  }

  constructor(props: DashboardProps) {
    super(props);
    const { 
      match: { params: { currentId } },
    } = props;
    
    const key = `dashboard-store${currentId}`;  
    const newState = JSON.parse(window.localStorage.getItem(key)) || {};

    this.state = { 
      ...newState,
      currentId: currentId 
    };
    this.updateDashboardCollection();
    this.updateCurrentDashboard(props);
    this.redraw = uuidv1();
  }
  
  updateDashboardCollection() {
    const dashboards = this.props.dashboards.getParsedItems as Dashboard[] || [];
    this.dashboards = dashboards.filter(o => 
      o.clientId === this.props.authStore.clientId
    );
  }

  /**
   *    Update current dashboard based on props
   */
  updateCurrentDashboard(_props?: DashboardProps) {
    const props = _props || this.props;

    const { 
      match: { params: { currentId} },
      authStore
    } = props;
    const { clientId } = authStore;
    
    if (this.state.typedId) {
      if (this.state.typedId === currentId) {
        this.currentDashboard = new Dashboard(this.state);
      } else {
        this.handleCancel();
      }
    } else {
      const items = this.dashboards;
      const itemIndex = items.findIndex(o => o.typedId === currentId);
        
      if ( itemIndex >= 0 ) {
        this.currentDashboard = items[itemIndex];
      } else {
        if (clientId) {
          let clientItems = items.filter(o => o.clientId === clientId);
          
          if (clientItems.length > 0) {
            this.currentDashboard = clientItems[0];
            this.updateDashboardRoute (this.currentDashboard.typedId);
          }
        }
      }
    }
  }

  componentDidUpdate() {
    const { 
      match: { params: { currentId } },
    } = this.props;
    if (this.state.currentId !== currentId) {
      this.setState({ currentId });
    }
    if (this.awaitingSave) {
      if (this.state.typedId) {
        let d = this.dashboards.find(o => o.typedId === this.state.typedId);
        if (
          d &&
          deepEqual(
            this.state,
            d.parseAbsolute()
          )
        ) {
          this.resetState();
        }
      } else {
        this.awaitingSave = false;
      }
    } else {
      this.fetchIfNewState();
    }

  }

  componentDidMount() {
    this.fetchIfNewState();
    // setTimeout(this.forceUpdate.bind(this), 5000);
  }

  fetchIfNewState() {
    const { typedId, currentId } = this.state;
    const shouldFetch = typedId || currentId;
    
    if (
      shouldFetch &&
      this.state.fetchedDashboard !== shouldFetch
    ) {
      
      const key = `dashboard-store${shouldFetch}`;  
      const newState = JSON.parse(localStorage.getItem(key));
      
      this.setState({
        ...newState,
        fetchedDashboard: shouldFetch
      });
    }    
  }

  /**
   *  reset the state to the normal state
   */
  resetState() {
    let endState: any = {};
    Object.keys(this.state).forEach(key => endState[key] = undefined);
    this.setState(endState);
  }
  
  /**
   *  Handle click on addnew
   */
  handleAddNew () {

    const { 
        match: { params: { currentId} },
        authStore
    } = this.props;
    const { clientId } = authStore;
    if (currentId) {
      this.handleCancel();
    }
    const typedId = uuidv1();
    const added = {
      typedId,
      clientId,
      name: ''
    };

    if (this.props.match.url.includes(currentId)) {
      let newurl = this.props.match.url.replace(currentId, typedId);
      this.props.history.push(newurl);
    } else {
      let newurl = this.props.match.path.split('/:currentId?')[0];
      newurl += `/${typedId}`;
      this.props.history.push(newurl);
    }
    this.setState(added);
  }

  /**
   *    Handle click on cancel button
   */
  handleCancel() {
    if (this.state.typedId) {
      if (window.confirm('Are you sure? All your changes will be lost.')) {
        this.resetState();
      } else {
        this.props.history.push(this.props.match.path.split(':currentId?')[0] + this.state.typedId);
      }
    } else {
      this.props.history.push(this.props.match.path.split(':currentId?')[0]);
    }
  }

  /**
   *    Handle click on delete button
   */
  handleDelete() {
    if (
      this.currentDashboard && 
      window.confirm('Are you sure you want to delete?')
    ) {
      this.props.dashboards.delete(this.currentDashboard);
      this.resetState();
    }
    return false;
  }

  /**
   *    Handle click on delete button
   */
  handleSave() {
    let result = new Dashboard(this.state);
    const { dashboards } = this.props;
    const items = this.dashboards;
    if (
      items.some(
        o => o.typedId === this.state.typedId
      )
    ) {
      dashboards.update(result);
    } else {
      dashboards.create(result);
    }
    this.awaitingSave = true;
  }

  handleClone() {
    const typedId = `db:${uuidv1()}`;
    if (
      this.currentDashboard
    ) {
      this.setState(
        {
          ...this.currentDashboard.parseAbsolute(),
          typedId
        }, 
        () => {
          this.updateDashboardRoute (typedId);
        }
      );
    }
  }

  handleEdit() {
    if (
      this.currentDashboard
    ) {
      this.setState({
        ...this.currentDashboard.parseAbsolute()
      });
    } else {
      console.error('unknown dashboard');
    }
  }

  /**
   * Handle change from the 
   */
  handleChange(e: any, {name, value}: any) {

    this.setState({ [name]: value });
  }

  handleChartChange(e: any, {name, value}: any) {
    const layout = new Dashboard(this.state).updateChart(value);
    this.setState({ layout });
  }

  onLayoutChange(currentLayout: any, layout: any): void {
    if (!deepEqual(
      layout,
      this.state.layout
    )) {
      this.setState({layout});
    }

    this.redraw = uuidv1();
    
  }
  
  updateDashboardRoute (typedId: string) {
    const { match: { path, params: { currentId }, url }, history } = this.props;

    if (url.includes(currentId)) {
      let newurl = url.replace(currentId, typedId);
      history.push(newurl);
    } else {
      let newurl = path.split('/:currentId?')[0];
      newurl += `/${typedId}`;
      history.push(newurl);
    }
  }

  /**
   * Gives the selection menu to select different dashboard
   */
  selection() {
    const dashboardItems = this.dashboards;
    const currentDashboard = this.currentDashboard;
    let options: JSX.Element[] =  (dashboardItems || [])
      .filter( dashboard => 
        typeof dashboard !== 'undefined'
      )
      .map( dashboard => {
        return (
          <Dropdown.Item
            key={dashboard.typedId}
            text={dashboard.name}
            as={Link}
            to={`/dashboard/${dashboard.typedId}`}
          />
        );
      });

    if (options && options.length > 0) {
      if (this.props.authStore.isSuperUser) {
        options.push(<Dropdown.Divider  key="defaultDashboardDivider"/>);
        options.push(
          <Dropdown.Item
            key="addNewButton"
            icon="add circle"
            as={Button}
            onClick={this.handleAddNew.bind(this)}
            text="Add New" 
          />
        );
          
      }
      return (
        <Grid.Column  width={3} key="selection-option">
          <Dropdown key="dashboard-selection" text={currentDashboard.name}>
            <Dropdown.Menu>
              {options}
            </Dropdown.Menu>
          </Dropdown>
        </Grid.Column>
      );
    } else if (this.props.authStore.isSuperUser) {
      return (
        <Button
          key="addNewButton"
          onClick={this.handleAddNew.bind(this)}
        >
          <Icon name="add circle" /> Add New
        </Button>
      );
    } else {
      return null;
    }
  }

  unoperated() {
    let currentDashboard: any = this.currentDashboard;

    var operationOptions: JSX.Element[] = []; 
    operationOptions.push(this.selection());
    
    if (
      currentDashboard &&
      this.props.authStore.isSuperUser
    ) {
      operationOptions.push(
        <Grid.Column  width={3} key="clone-dashboard" className="dashboard-selector">
            <a href="#" onClick={this.handleClone.bind(this)}>
                <Icon name="copy" /> Clone Dashboard
            </a>
        </Grid.Column>
      );

      operationOptions.push(
        <Grid.Column  width={3} key="edit-dashboard" className="dashboard-selector">
            <a href="#" onClick={this.handleEdit.bind(this)}>
                <Icon name="edit" /> Edit Dashboard
            </a>
        </Grid.Column>
      );
      
      operationOptions.push(
        <Grid.Column width={3} key="delete-dashboard" className="dashboard-selector">  
          <a href="#" onClick={this.handleDelete.bind(this)}>
              <Icon name="trash" /> Delete Dashboard
          </a>
        </Grid.Column>
      );
    }

    return operationOptions;
  }

  operated() {
    let currentDashboard: any = this.currentDashboard ||  {};
    
    var operationOptions: JSX.Element[] = [];
    operationOptions.push(
      <Grid.Column mobile={12} tablet={12} computer={3} key="name-input" className="dashboard-name-input">
          <Form>
              <Form.Group>
                  <Form.Input 
                    placeholder="Dashboard Name"
                    name="name"
                    defaultValue={this.state.name}
                    className="dashbaord-name-input"
                    onChange={this.handleChange.bind(this)} 
                  />
              </Form.Group>
          </Form>
      </Grid.Column>
    );
    let defaultValue = typeof currentDashboard.getCharts === 'function' ?
      currentDashboard.getCharts() : [];
    
    operationOptions.push(
      <Grid.Column  mobile={12} tablet={12} computer={8} key="add-chart" className="add-chart dashboard-chart-options">
          <ChartOptions 
            multiple
            search
            defaultValue={defaultValue}
            onChange={this.handleChartChange.bind(this)}
          /> 
      </Grid.Column>
    );

    operationOptions.push(
      <Grid.Column  
        mobile={12}
        tablet={12}
        computer={3} 
        key="save-cancel-button"
        className="dashboard-save-prompt"
      >
        <div>
          <Button.Group floated="right">
              <Button 
                onClick={this.handleCancel.bind(this)}
              >
                <Icon name="cancel" /> Cancel
              </Button>
              <Button 
                positive
                disabled={this.state.name === undefined || this.state.name === ''} 
                onClick={this.handleSave.bind(this)}
              >
                <Icon name="save" /> Save
              </Button>
          </Button.Group>
        </div>
      </Grid.Column>
    );

    return operationOptions;
  }

  getOperations() {
    if ( this.isEdit ) {
        return this.operated();
    } else {
      return this.unoperated();
    }
  }

  render() {
    this.updateDashboardCollection();
    this.updateCurrentDashboard();

    var options = this.getOperations();
    return (
      <div>
        <div className="dashboard-container container">
          <Grid className="dashboard-options" divided>
            <Grid.Row stretched columns={12}>
                {options}
            </Grid.Row>
            {/* <RedirectIfLoggedOut /> */}
          </Grid>
          {this.renderDashboardView()}
        </div>
      </div>
    );
  }

  toggleKey(key: string) {
    const newState = {
      [key]: !this.state[key]
    };
    const storageKey = `dashboard-store${this.state.currentId}`;
    const newStorage = {
      ...JSON.parse(window.localStorage.getItem(storageKey)),
      ...newState
    };

    this.setState({
      ...newState
    });
    window.localStorage.setItem(storageKey, JSON.stringify(newStorage));
  }

  renderDashboardView() {
    const currentDashboard = this.currentDashboard;
    const { isSuperUser } = this.props.authStore;

    if (currentDashboard) {
        const {layout} = currentDashboard;
        const breakingpoints = ['lg', 'md', 'sm', 'xs', 'xxs'];
        const knownIds = [];
        const isStatic = !this.isEdit;
        let renderLayout = {};
        
        breakingpoints.forEach(key => {
          renderLayout[key] = (layout[key] || []).map(l => {
            if (!knownIds.some(kid => kid === l.i)) {
                knownIds.push(l.i);
            }
            return Object.assign(
              {
                static: isStatic
              },
              l
            );
          });
        });
        
        knownIds.forEach(id => {
          let lastknown;
          // initial last known
          breakingpoints.some(point => {
            const layoutPoint = renderLayout[point];
            const lastKnownIndex = layoutPoint.findIndex(o => o.i === id);
            if (lastKnownIndex >= 0) {
              lastknown = layoutPoint[lastKnownIndex];
              return true;
            } else {
              return false;
            }
          });
          
          breakingpoints.forEach(point => {
            const layoutPoint = renderLayout[point];
            const lastKnownIndex = layoutPoint.findIndex(o => o.i === id);
            
            if (lastKnownIndex >= 0) {
              lastknown = layoutPoint[lastKnownIndex];
            } else {
              layoutPoint.push(lastknown);
            }
          });
          
        });

        let chartItems = this.props.charts.getParsedItems as Chart[];
        chartItems = chartItems.filter(o => knownIds.includes(o.typedId));
        if (!knownIds.every( id => chartItems.some(item => item.typedId === id))) {
          return (<div>Loading...</div>);
        }

        let widgetWrapper;
        
        if (isStatic) {
          widgetWrapper = 
            (widget, element) =>  {
              const additionalConfigurations = [];
              const geoRenderKey = `geo-render-${widget.typedId}`;
              let geoSpread = this.state[geoRenderKey];

              if (typeof geoSpread === 'undefined') {
                geoSpread = widget.geospread;
              } 

              if (geoSpread) {
                additionalConfigurations.push(
                  <a 
                    href="javascript:void(0)" 
                    key="switch-geo chart"
                    onClick={this.toggleKey.bind(this, geoRenderKey)}
                  >
                    <Icon name="area chart"/> Show Chart
                  </a>
                );
                const showAllOptionKey = `show-all-geo-${widget.typedId}`;
                if (this.state[showAllOptionKey]) {
                  additionalConfigurations.push(
                    <a 
                      href="javascript:void(0)"
                      key="show-all"
                      onClick={this.toggleKey.bind(this, showAllOptionKey)}
                    >
                      <Icon name="low vision"/> Show on Hover
                    </a>
                  );
                } else {
                  additionalConfigurations.push(
                    <a
                      href="javascript:void(0)"
                      key="show-all"
                      onClick={this.toggleKey.bind(this, showAllOptionKey)}
                    >
                      <Icon name="eye"/> Show all
                    </a>
                  );
                }
              } else {
                additionalConfigurations.push(
                  <a
                    href="javascript:void(0)"
                    key="switch-geo"
                    onClick={this.toggleKey.bind(this, geoRenderKey)}
                  >
                    <Icon name="map"/> Show geo map
                  </a>
                );
              }

              return (
                <div key={this.redraw} className="configurable-widget">
                  <div className="configurations">
                    {additionalConfigurations}
                    <Link key="details-link" to={`/chart/${widget.typedId}`}><Icon name="expand"/> Details</Link>
                  </div>
                  <div className="widget-frame">
                    {element}
                  </div>
                </div>
              );
            };
        } else {
          widgetWrapper = 
            (widget, element) =>  (
              <div key={this.redraw} className="configurable-widget">
                <div className="widget-frame">
                  {element}
                </div>
              </div>
            );
        }
        
        const widgets = chartItems.map( widget => {
          const geoRenderKey = `geo-render-${widget.typedId}`;          
          let geoSpread = this.state[geoRenderKey];

          if (typeof geoSpread === 'undefined') {
            geoSpread = widget.geospread;
          } 
          // tslint:disable:no-string-literal
          let gridIndex = renderLayout['md'].findIndex(o => o.i === widget.typedId);
          let dataGrid = gridIndex >= 0 ? renderLayout['md'][gridIndex] : undefined;
          // tslint:enable:no-string-literal
          return (
              <div 
                key={widget.typedId} 
                className="dashboard-widget"
                data-grid={dataGrid}
              >
                {widgetWrapper(
                  widget, 
                  (
                    <Widget 
                      isDashboard 
                      onLegendClick={(sensor) => {
                        if (
                          sensor.unitSensor && sensor.unitSensor.typedId
                        ) {
                          this.props.routing.push(`/unitsensor/${sensor.unitSensor.typedId}`);
                        }
                      }}
                      chart={widget}
                      {...this.props}
                      {...this.state}
                      geospread={geoSpread}
                      lockDetails={this.state[`show-all-geo-${widget.typedId}`]}
                    />
                  )
                )}  
              </div>
            );
        });

        return (
            <ResponsiveReactGridLayout 
                onLayoutChange={this.onLayoutChange.bind(this)} 
                className="dashboard-view" 
                layouts={renderLayout} 
                rowHeight={15}
                margin={[15, 31]}
                breakpoints={{lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0}}
                cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
            >
                {widgets}
            </ResponsiveReactGridLayout>
        );
    } else {
        return (
          <div className="click-through">
            <CenterFramed className="click-through"> 
              <div className="text-center">
                Please {isSuperUser ?
                  `${this.dashboards.length > 0 ? 'select a' : 'add new'} dashboard` :
                  `Please contact GTM personel for dashboard`
                }
              </div>
            </CenterFramed>
          </div>
        );
    }
  }
}


// WEBPACK FOOTER //
// ./src/container/Dashboard/Dashboard.tsx